import STOCK_ICON from 'assets/png/increase.png';

import { PATH, PORTALS_NAMES } from "./constants";

export const sideBarNavigation = Object.values(PORTALS_NAMES).reduce((acc, portalName) => {
    acc[portalName] = Object.values(PATH[portalName].children)
        .filter(x => x.sidebar)
        .map((pageData, index) => ({
            id: index + 1,
            path: pageData.path,
            path_id: pageData.path_id,
            icon: STOCK_ICON,
            pageName: pageData.sidebar.name || pageData.pageName
        }))
    return acc
}, {})
